import React, { useState } from 'react';
import { Star, Quote, ChevronLeft, ChevronRight } from 'lucide-react';

const REVIEWS = [
  {
    name: 'Priya Menon',
    city: 'Bangalore',
    quote: 'Booked a bike taxi at 8:45 AM peak hour \u2014 driver was at my door in 90 seconds. Saved me from being late to a client call. Now my default for short hops.',
    rating: 5,
    avatar: 'P',
    color: 'bg-[#FFE5D2] text-[#FF6A1A]',
  },
  {
    name: 'Arjun Reddy',
    city: 'Hyderabad',
    quote: 'The fare lock-in is the killer feature. No more surprise surge at midnight. I take OTW Sedans to the airport now \u2014 \u20b9100\u2013150 cheaper than the rest.',
    rating: 5,
    avatar: 'A',
    color: 'bg-[#E5EEFF] text-[#2C5BFF]',
  },
  {
    name: 'Fatima Khan',
    city: 'Mumbai',
    quote: 'As a woman who travels late from Andheri, the SOS button and live trip-share gave my parents real peace of mind. The drivers are polite and the cars are clean.',
    rating: 5,
    avatar: 'F',
    color: 'bg-[#EAF8EE] text-[#0E8A3F]',
  },
  {
    name: 'Rohan Iyer',
    city: 'Pune',
    quote: 'I drive an Auto for ON THE WAY on weekends. Daily UPI payouts, zero commission games, and the driver app actually works on a 2 GB phone. Earned \u20b918,400 last month part-time.',
    rating: 5,
    avatar: 'R',
    color: 'bg-[#FFF3E0] text-[#B45309]',
  },
];

export default function Testimonials() {
  const [idx, setIdx] = useState(0);
  const r = REVIEWS[idx];

  const prev = () => setIdx((i) => (i - 1 + REVIEWS.length) % REVIEWS.length);
  const next = () => setIdx((i) => (i + 1) % REVIEWS.length);

  return (
    <section className="bg-[#f5f5f3] py-24 md:py-32">
      <div className="max-w-[1280px] mx-auto px-5 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <span className="text-[11px] font-semibold tracking-[0.18em] text-[#FF6A1A]">LOVED BY RIDERS</span>
            <h2 className="mt-3 text-[34px] md:text-[46px] font-semibold tracking-[-0.02em] text-[#0f0f10] leading-[1.05]">
              4.9 ★ from 218,000+ riders
            </h2>
          </div>
          <div className="flex items-center gap-2">
            <button onClick={prev} aria-label="Previous" className="w-11 h-11 rounded-full bg-white ring-1 ring-black/[0.06] hover:ring-[#FF6A1A] grid place-items-center transition-colors">
              <ChevronLeft size={18} />
            </button>
            <button onClick={next} aria-label="Next" className="w-11 h-11 rounded-full bg-[#0f0f10] text-white hover:bg-[#FF6A1A] grid place-items-center transition-colors">
              <ChevronRight size={18} />
            </button>
          </div>
        </div>

        <div className="grid md:grid-cols-5 gap-6">
          {/* Featured big card */}
          <div className="md:col-span-3 bg-white rounded-3xl p-8 md:p-12 ring-1 ring-black/[0.05] relative overflow-hidden">
            <Quote size={48} className="absolute -top-2 -right-2 text-[#FF6A1A]/10" />
            <div className="flex items-center gap-1">
              {Array.from({ length: r.rating }).map((_, i) => (
                <Star key={i} size={16} className="fill-[#FFB400] stroke-[#FFB400]" />
              ))}
            </div>
            <p className="mt-5 text-[20px] md:text-[24px] leading-[1.45] text-[#0f0f10] tracking-[-0.01em] font-medium">
              “{r.quote}”
            </p>
            <div className="mt-7 flex items-center gap-3">
              <div className={`w-12 h-12 rounded-full grid place-items-center font-bold ${r.color}`}>
                {r.avatar}
              </div>
              <div>
                <div className="text-[15px] font-semibold text-[#0f0f10]">{r.name}</div>
                <div className="text-[12.5px] text-[#6b6b70]">{r.city} · OTW rider</div>
              </div>
            </div>
          </div>

          {/* Side mini cards */}
          <div className="md:col-span-2 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 gap-4">
            {REVIEWS.filter((_, i) => i !== idx).slice(0, 2).map((m) => (
              <button
                key={m.name}
                onClick={() => setIdx(REVIEWS.findIndex(x => x.name === m.name))}
                className="bg-white rounded-2xl p-5 text-left ring-1 ring-black/[0.05] hover:ring-[#FF6A1A] transition-colors"
              >
                <div className="flex items-center gap-1 mb-3">
                  {Array.from({ length: m.rating }).map((_, i) => (
                    <Star key={i} size={12} className="fill-[#FFB400] stroke-[#FFB400]" />
                  ))}
                </div>
                <p className="text-[13.5px] text-[#3a3a3d] leading-relaxed line-clamp-3">“{m.quote}”</p>
                <div className="mt-4 flex items-center gap-2">
                  <div className={`w-8 h-8 rounded-full grid place-items-center font-bold text-[12.5px] ${m.color}`}>
                    {m.avatar}
                  </div>
                  <div>
                    <div className="text-[13px] font-semibold text-[#0f0f10]">{m.name}</div>
                    <div className="text-[11px] text-[#6b6b70]">{m.city}</div>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
